enum Phase {
  Backlog = 'backlog',
  Blocked = 'blocked',
  Wip = 'wip',
  Review = 'review',
  Test = 'test',
  Deployable = 'deployable',
  Done = 'done',
}

type PhaseMetadataItem = {
  id: string;
  label: string;
  color: string;
};

export { Phase };
export type { PhaseMetadataItem };
